
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabservicenearme() {



    const cardData =
    {
        keyword: 'Cabs Services Near Me',
        heading: 'Platinum24 Cabs: Cabs Services Near Me',
        headingDescription: ' Platinum24 Cabs is your trusted choice when searching for Cabs Services Near Me in Pune and nearby areas. With 24/7 availability, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures you always find the right cab for your travel needs—whether it’s a quick city ride, an airport transfer, or an outstation trip. Our professional drivers, clean vehicles, and transparent pricing provide a safe and hassle-free experience every time. From solo passengers to families and corporate groups, Platinum24 Cabs guarantees comfort, punctuality, and reliability wherever you need to go.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, is Pune’s iconic fort palace and a symbol of Maratha pride. Once the seat of the Peshwas, it narrates tales of power and grandeur. Though partially destroyed by fire in 1828, its mighty gates, fountains, and ruins still attract thousands. The evening light-and-sound show recreates the era of Bajirao and Mastani. Tourists love exploring its historic corridors and gardens. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is one of Pune’s most beautiful monuments with Indo-Italian architecture. It is historically important as Mahatma Gandhi, Kasturba Gandhi, and Sarojini Naidu were imprisoned here during the Quit India Movement. The palace now serves as a museum showcasing Gandhi’s personal belongings and photos. Its sprawling lawns make it peaceful and picturesque. It is also a national memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s symbol of freedom and heritage."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is famous for the 1670 battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. The fort offers panoramic views of the Sahyadris and is a popular trekking destination. Visitors explore bastions, temples, and memorials that echo Maratha bravery. In monsoon, waterfalls and mist make it magical. Locals serve traditional pithla-bhakri at the fort. Sinhagad is Pune’s blend of history, adventure, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, is a major attraction during Ganesh Chaturthi when grand celebrations take place. The temple also runs charitable trusts and cultural events. Devotees from all over India visit year-round for darshan. Its spiritual aura is both vibrant and peaceful. Dagdusheth Ganpati is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is an ancient rock-cut shrine dedicated to Lord Shiva. Located in the heart of the city, it offers peace away from the urban buzz. The temple features huge stone pillars, a Nandi mandapa, and detailed carvings. Evening prayers add to its mystical ambiance. It showcases India’s ancient architectural craftsmanship. Pataleshwar is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, reflecting India’s cultural traditions. Exhibits include musical instruments, sculptures, ornaments, and household antiques. The recreation of Mastani Mahal is a highlight. History enthusiasts and students find it educational and fascinating. The museum preserves art spanning centuries. It is Pune’s cultural and artistic treasure trove."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. At the hilltop stands the Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. The climb of 103 steps is a blend of devotion and adventure. The hill also houses museums and smaller shrines. Sunrise and sunset views from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for spirituality and wellness. Spread across lush gardens, it attracts visitors from all over the world. The ashram offers meditation sessions, yoga, and personal growth workshops. Japanese Zen gardens and serene meditation halls enhance the experience. It is a place for peace, rejuvenation, and self-discovery. Osho Ashram is Pune’s international center of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, also known as the Okayama Friendship Garden, is Pune’s largest landscaped park. Inspired by Japan’s Korakuen Garden, it features streams, stone bridges, and manicured lawns. Families enjoy peaceful strolls, picnics, and photography here. The garden symbolizes Indo-Japanese friendship and culture. Seasonal flowers make it more enchanting. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend spot near Pune. It supplies water to the city while offering scenic views of hills and flowing waters. During monsoon, the overflowing dam creates spectacular sights. Street vendors selling hot corn and tea add charm to the visit. It also serves as a gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat for families and travelers alike."
  }
],



"services": [
    {
      "name": "Taxi Near Me in Pimpri Chinchwad",
      "description": "Find nearby taxis in Pimpri Chinchwad quickly — ideal for local rides, airport transfers, or city travel."
    },
    {
      "name": "Cabs Services Near Me in Pune",
      "description": "Local cab services across Pune city, available on-demand with verified drivers and flexible booking."
    },
    {
      "name": "Taxi Near Me in Pune",
      "description": "Easily locate nearby taxis in Pune at your current location, with instant booking and ride tracking."
    },
    {
      "name": "Taxi Service Near Me in Pune",
      "description": "Reliable taxi services around Pune — 24/7 availability, multiple vehicle options, and transparent pricing."
    },
    {
      "name": "Cabs Near Me in Pune",
      "description": "Locate nearby cabs in Pune city quickly — ideal for short intra‑city trips or urgent travel needs."
    },
    {
      "name": "Cab Company Near Me in Pune",
      "description": "Trusted cab companies operating near you in Pune, offering quality service, safe drivers, and customer support."
    },
    {
      "name": "Taxi Cab Near Me in Viman Nagar",
      "description": "Taxi services close to Viman Nagar area — perfect for last‑mile connectivity or local commuting."
    },
    {
      "name": "Taxi Company Near Me in Kharadi",
      "description": "Cab companies servicing the Kharadi area, with easy booking and prompt pickups."
    },
    {
      "name": "Call Taxi Near Me in Kalyani Nagar",
      "description": "On‑call taxi services around Kalyani Nagar — just call and get a cab at your doorstep."
    },
    {
      "name": "Cheapest Taxi Service Near Me in Koregaon Park",
      "description": "Budget taxi services around Koregaon Park area — ideal for economical local trips."
    },
    {
      "name": "Local Taxi Service Near Me in Wadgaon Sheri",
      "description": "Reliable local taxi service in Wadgaon Sheri for everyday commuting with ease."
    },
    {
      "name": "Taxi Cab Service Near Me",
      "description": "Comprehensive taxi cab services around your vicinity — easy to book via app or call."
    },
    {
      "name": "Taxi Booking Near Me in Hadapsar",
      "description": "Book taxis easily in Hadapsar area, with instant confirmation and driver details."
    },
    {
      "name": "24 Hour Taxi Service Near Me",
      "description": "Round‑the‑clock taxi availability near you — perfect for late‑night or early‑morning travel."
    },
    {
      "name": "Local Cab Company in Lohegaon Airport",
      "description": "Airport cab services around Lohegaon — for arrivals, departures, and nearby transfers."
    },
    {
      "name": "Best Taxi Service Near Me",
      "description": "Top‑rated taxis in your area with verified reviews, quality vehicles, and excellent service."
    },
    {
      "name": "Book a Taxi Online Near Me",
      "description": "Convenient online taxi booking near your location — instant quotes and bookings."
    },
    {
      "name": "Local Cab Service Near Me in Chandan Nagar",
      "description": "Cabs servicing the Chandan Nagar area, offering quick pickups and local connectivity."
    },
    {
      "name": "Nearest Cab Service Kothrud",
      "description": "Cab services nearest to Kothrud area — ideal for quick local travel."
    }
  ],
  "tableData": [
    ["Taxi Near Me in Pimpri Chinchwad", "Cabs Services Near Me in Pune"],
    ["Taxi Near Me in Pune", "Taxi Service Near Me in Pune"],
    ["Cabs Near Me in Pune", "Cab Company Near Me in Pune"],
    ["Taxi Cab Near Me in Viman Nagar", "Taxi Company Near Me in Kharadi"],
    ["Call Taxi Near Me in Kalyani Nagar", "Cheapest Taxi Service Near Me in Koregaon Park"],
    ["Local Taxi Service Near Me in Wadgaon Sheri", "Taxi Cab Service Near Me"],
    ["Taxi Booking Near Me in Hadapsar", "24 Hour Taxi Service Near Me"],
    ["Local Cab Company in Lohegaon Airport", "Best Taxi Service Near Me"],
    ["Book a Taxi Online Near Me", "Local Cab Service Near Me in Chandan Nagar"],
    ["Nearest Cab Service Kothrud", "—"]
  ],


  "whychoose": [
    {
      "WhyChooseheading": "Reliable Cabs Services Near You Anytime, Anywhere",
      "WhyChoosedescription": "Platinum24 Cabs ensures quick and dependable cab availability near your location for hassle-free travel."
    },
    {
      "WhyChooseheading": "Fast Pickup with GPS-Enabled Nearby Drivers",
      "WhyChoosedescription": "Our drivers are always on standby near your area, ensuring minimal wait time and prompt service."
    },
    {
      "WhyChooseheading": "Affordable Local and Outstation Cab Services",
      "WhyChoosedescription": "Enjoy budget-friendly rates for both short city rides and longer outstation journeys from your location."
    },
    {
      "WhyChooseheading": "Clean, Comfortable, and Well-Maintained Fleet",
      "WhyChoosedescription": "Every ride comes with a clean, sanitized vehicle equipped for comfort, safety, and reliability."
    },
    {
      "WhyChooseheading": "Verified Drivers for Safe and Trustworthy Rides",
      "WhyChoosedescription": "All Platinum24 Cabs drivers are background-checked and professionally trained for your peace of mind."
    },
    {
      "WhyChooseheading": "Book Cabs Instantly with 24/7 Availability",
      "WhyChoosedescription": "Whether it's day or night, Platinum24 Cabs is ready to pick you up from wherever you are."
    },
    {
      "WhyChooseheading": "Easy Online Booking and Real-Time Tracking",
      "WhyChoosedescription": "Use our website or app to book instantly and track your cab in real-time for full control over your ride."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Needs",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, or SUVs depending on your group size, luggage, and comfort preference."
    }
  ]

















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services near my location?',
        answer: 'Yes, Platinum24 Cabs provides convenient and reliable cab services near your location to ensure easy and quick pickups.',
    },
    {
        question: 'How can I find Platinum24 Cabs services near me?',
        answer: 'You can find and book cabs near you through our website or mobile app by enabling location access or by contacting our customer support.',
    },
    {
        question: 'What types of cabs are available near me through Platinum24 Cabs?',
        answer: 'We offer a wide range of vehicles including sedans, SUVs, and premium cars available near your location for various travel needs.',
    },
    {
        question: 'Are Platinum24 Cabs drivers nearby experienced and reliable?',
        answer: 'Absolutely! All our drivers near your area are professional, experienced, and trained to provide safe and comfortable rides.',
    },
    {
        question: 'Can I book a cab for immediate pickup near me?',
        answer: 'Yes, Platinum24 Cabs supports instant bookings and quick pickups based on cab availability near your location.',
    },
    {
        question: 'Are there any safety measures for cabs operating near me?',
        answer: 'Yes, all vehicles are regularly sanitized and our drivers follow strict safety protocols to ensure your safety.',
    },
    {
        question: 'Can I customize my pickup and drop-off locations when booking a cab near me?',
        answer: 'Yes, you can specify your exact pickup and drop-off points for a seamless journey with Platinum24 Cabs.',
    },
    {
        question: 'Do you offer corporate cab services near my location?',
        answer: 'Yes, Platinum24 Cabs provides tailored corporate travel solutions including priority support and flexible billing for nearby locations.',
    },
    {
        question: 'Is it possible to hire cabs near me for hourly or multi-day rentals?',
        answer: 'Yes, we offer hourly and multi-day rental packages for cabs near your location to meet your travel needs.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rajesh Kumar',
        feedback: 'Platinum24 Cabs was just around the corner and picked me up on time. The service was prompt and the driver was courteous.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Mehta',
        feedback: 'Booking a cab near me with Platinum24 Cabs was so easy and hassle-free. The vehicle was clean and the ride was smooth.',
        rating: 5,
    },
];
































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const cabsServicesNearMeSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Cabs Services Near Me",
  "image": "https://www.platinum24cab.com/assets/images/cabs-services-near-me.jpg",
  "description": "Find reliable and affordable cabs services near you in Pune including Pimpri Chinchwad, Viman Nagar, Kharadi, Hadapsar, Koregaon Park, and more. 24/7 taxi booking with Platinum24 Cabs.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune, Pimpri Chinchwad, Viman Nagar, Kharadi, Hadapsar, Koregaon Park, Lohegaon Airport, Kaylani Nagar, Wadgaon Sheri, Chandan Nagar, Kothrud"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/cabs-services-near-me"
  }
};






    return (
        <div>

<Helmet>
  <title>Cabs Services Near Me in Pune | 24/7 Local Taxi Booking | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Find reliable and affordable cabs services near you in Pune including Pimpri Chinchwad, Viman Nagar, Kharadi, Hadapsar, Koregaon Park, and more. 24/7 taxi booking with Platinum24 Cabs."
  />
  <meta
    name="keywords"
    content="near me taxi in Pimpri Chinchwad, Cabs services near me in Pune, Taxi near me in Pune, Taxi service near me in Pune, cabs near me in Pune, cab company near me in Pune, taxi cab near me in Viman Nagar, taxi company near me in kharadi, call taxi near me Kaylani Nagar, cheapest taxi service near me koregaon park, Local taxi service near me, Wadgaon Sheri, Taxi cab service near me, Taxi booking near me Hadapsar, 24 hour taxi service near me, Local cab company in Lohegaon airport, Best Taxi Service near me, Book a Taxi online near me, Local cab service near me chandan nagar, nearest cab service kothrud"
  />
  <script type="application/ld+json">
    {JSON.stringify(cabsServicesNearMeSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/15.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabservicenearme;